import { useEvent } from "shared/lib/useEvent"

import { useTeamMemberMutations } from "entities/team-members/model/useTeamMemberMutations"
import {
  CreateTeamMemberInput,
  CreateTeamMemberInputSchema
} from "entities/team-members/types/CreateTeamMemberInput"
import z from "zod"

import { CreateTeamMemberArgs } from "../types/TeamMemberFormHandlers"

export function useTeamMemberFormHandlers() {
  const { createTeamMember, createMultipleTeamMembers, updateTeamMember } =
    useTeamMemberMutations()

  const handleCreateTeamMember = useEvent(
    ({ formData, teamID }: CreateTeamMemberArgs) => {
      const teamMember = (
        formData.teamMembers.filter(
          member => z.safeParse(CreateTeamMemberInputSchema, member).success
        ) as CreateTeamMemberInput[]
      )[0]

      return createTeamMember({
        teamMember,
        teamID
      })
    }
  )

  const handleCreateMultipleTeamMembers = useEvent(
    ({ formData, teamID }: CreateTeamMemberArgs) => {
      const teamMembers = formData.teamMembers.filter(
        teamMember =>
          z.safeParse(CreateTeamMemberInputSchema, teamMember).success
      ) as CreateTeamMemberInput[]
      return createMultipleTeamMembers({
        teamMembers,
        teamID
      })
    }
  )

  return {
    handleCreateTeamMember,
    handleCreateMultipleTeamMembers,
    handleUpdateTeamMember: updateTeamMember
  }
}
